import type { ProductData } from "~/domains/product/types/ProductData";

export const ADD_PRODUCT_BASIC = "products: add basic product info";

export function addBaseProductDataAction(products: ProductData | ProductData[], override: boolean = false) {
  return {
    type: ADD_PRODUCT_BASIC,
    payload: {
      products: Array.isArray(products) ? products : [products],
    },
  } as const;
}
